import type { IMarket } from "~/types/event";
import { getMarketSettlement } from "~/utils/resolution/getMarketSettlement";
import { RESULT_WORD } from "~/utils/resolution/resolutionLabels";

import { LINES_BY_STATUS } from "./constants";

export const getStatusCellLines = (market: IMarket): readonly string[] => {
  const { result } = getMarketSettlement(market);

  return result ? [RESULT_WORD[result]] : LINES_BY_STATUS[market.unifiedStatus];
};
